module.exports = __webpack_public_path__ + "img/service18.20562ad6.png";